'use strict';

var _require = require('./baseProperties'),
    baseProperties = _require.baseProperties;

module.exports.DateiuploadSchema = {
  title: 'Dateiupload',
  type: 'object',
  properties: Object.assign({}, baseProperties)
};


//////////////////
// WEBPACK FOOTER
// ./~/fobclient/lib/schema/dateiupload.js
// module id = heao
// module chunks = 0